/**
 * Format passed number into a readable string
 */
export const number = (number) => {
  const formatter = Intl.NumberFormat('en-US')

  if (number < 1000) {
    return number
  }

  if (number >= 1000 && number < 1_000_000) {
    return (number / 1000).toFixed(2).replace(/\.?0+$/, '') + 'k'
  }

  if (number >= 1_000_000 && number < 1_000_000_000) {
    return (number / 1_000_000).toFixed(2).replace(/\.?0+$/, '') + 'M'
  }

  if (number >= 1_000_000_000 && number < 1_000_000_000_000) {
    return (number / 1_000_000_000).toFixed(2).replace(/\.?0+$/, '') + 'B'
  }

  if (number >= 1_000_000_000_000 && number < 1_000_000_000_000_000) {
    return (number / 1_000_000_000_000).toFixed(2).replace(/\.?0+$/, '') + 'T'
  }

  return formatter.format(number)
}

export const creditsNumber = (number) => {
  if (typeof number !== 'number' || isNaN(number)) return ''
  return number.toLocaleString('en-US')
}
